import {
    ChangeDetectionStrategy, Component, ElementRef, OnInit,
    ViewChild
} from "@angular/core";
import Highcharts from "highcharts";
import Exporting from "highcharts/modules/exporting";
import funnel from "highcharts/modules/funnel";


Exporting(Highcharts);
funnel(Highcharts);

@Component({
  selector: "app-analytics-sms-conversion",
  templateUrl: "./analytics-sms-conversion.component.html",
  styleUrls: ["./analytics-sms-conversion.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AnalyticsSmsConversionComponent implements OnInit {
  @ViewChild("container1", { read: ElementRef, static: true })
  container1: ElementRef;

  constructor() {}

  ngOnInit() {
    Highcharts.setOptions({
      colors: ["#03c0c2", "#868E96", "#72CACB"],
    });

    Highcharts.chart(this.container1.nativeElement, {
      chart: {
        height: 330,
        type: "funnel",
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      exporting: {
        buttons: {
          contextButton: {
            enabled: false,
          },
        },
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b> ({point.y:,.0f})",
            // color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || '#03c0c2',

            softConnector: true,
          },
          center: ["40%", "50%"],
          neckWidth: "20%",
          neckHeight: "7%",
          width: "50%",
          height: "250px",
        },
      },
      legend: {
        enabled: false,
      },
      series: [
        {
          name: "Unique users",
          data: [
            ["Invites Sent", 2355],
            ["Opened", 355],
          ],
        },
      ],
    });
  }
}
